import { Modal } from "@mui/material";
import gifTour from "./../../../../assets/Animação_tour.gif";

import { BackgroundModal } from "../../../../components/BackgroundModal";
import { Button } from "../../../../components/Button";
import styles from "./styles.module.scss";

interface TutorialModalProps {
  openTutorialModal: boolean;
  setCloseTutorialModal: () => void;
}

const TutorialModal = ({
  openTutorialModal,
  setCloseTutorialModal,
}: TutorialModalProps) => {
  return (
    <BackgroundModal isModalOpen={openTutorialModal}>
      <Modal
        className={styles.modalTutorial}
        open={openTutorialModal}
        onClose={() => setCloseTutorialModal()}
      >
        <div className={styles.box}>
          <p style={{ color: "#212121", marginBottom: "1rem" }}>
            Bem-vindo! Segue nosso tutorial para criar sua página personalizada.
          </p>

          <img
            src={gifTour}
            alt="Tutorial"
            style={{ width: "100%", borderRadius: 8 }}
          />
          <Button
            variant="solidPurple"
            content="Pular Tutorial"
            onClick={() => setCloseTutorialModal()}
            style={{ fontSize: "1rem", margin: "1rem auto 0" }}
          />
        </div>
      </Modal>
    </BackgroundModal>
  );
};

export default TutorialModal;
